import { useEffect, useState, useMemo } from 'react';
import { calculateDurationBytimestamp } from '~/utils/moment';

export const useReactiveDuration = (startTimestamp) => {
  const [updateTicker, setUpdateTicker] = useState(Date.now());

  useEffect(() => {
    if (!startTimestamp) return () => {};

    const interval = setInterval(() => {
      setUpdateTicker(Date.now());
    }, 3000);

    return () => clearInterval(interval);
  }, [startTimestamp]);

  const duration = useMemo(() => {
    if (!startTimestamp) return '0:00:00';
    return calculateDurationBytimestamp(startTimestamp);
  }, [startTimestamp, updateTicker]);

  return duration;
};
